import { Routes, Route, Navigate, NavLink, Outlet } from "react-router-dom";
import { UsersPage } from "./pages/Users";
import { FirmsAdminPage } from "./pages/Firms";
import { IntelPage } from "./pages/Intel";
import { SystemPage } from "./pages/System";
import { AdminAuditPage } from "./pages/Audit";
import { ConflictsPage } from "./pages/Conflicts";

export function AdminApp() {
  return (
    <div className="min-h-full bg-background text-foreground">
      <Routes>
        <Route element={<Shell />}>
          <Route index element={<Navigate to="/system" replace />} />
          <Route path="/system" element={<SystemPage />} />
          <Route path="/users" element={<UsersPage />} />
          <Route path="/firms" element={<FirmsAdminPage />} />
          <Route path="/intel" element={<IntelPage />} />
          <Route path="/conflicts" element={<ConflictsPage />} />
          <Route path="/audit" element={<AdminAuditPage />} />
        </Route>
      </Routes>
    </div>
  );
}

function Shell() {
  return (
    <div className="grid min-h-screen grid-cols-[14rem_1fr]">
      <aside className="border-r border-border bg-card/40 p-4">
        <div className="mb-2">
          <div className="text-lg font-semibold tracking-tight">PFH</div>
          <div className="pfh-heading text-[10px] text-accent">Admin</div>
        </div>
        <nav className="mt-6 flex flex-col gap-1">
          <NavItem to="/system" label="System" />
          <NavItem to="/users" label="Users" />
          <NavItem to="/firms" label="Firms" />
          <NavItem to="/intel" label="Intel" />
          <NavItem to="/conflicts" label="Conflicts" />
          <NavItem to="/audit" label="Audit (all)" />
        </nav>
      </aside>
      <main className="p-6">
        <div className="pfh-admin-banner">⚠ admin surface — actions here affect all users</div>
        <Outlet />
      </main>
    </div>
  );
}

function NavItem({ to, label }: { to: string; label: string }) {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        `rounded-md px-3 py-2 text-sm ${
          isActive
            ? "bg-accent/15 text-accent"
            : "text-muted-foreground hover:bg-muted hover:text-foreground"
        }`
      }
    >
      {label}
    </NavLink>
  );
}
